// Addon Enhancements for Shopify

document.addEventListener("DOMContentLoaded", function () {
  // Initialize the clickable addons and styling
  initializeAddonEnhancements();

  // Add descriptions to addons
  enhanceAddonProducts();

  // Try again after a delay to ensure addons are fully loaded
  setTimeout(function () {
    initializeAddonEnhancements();
    enhanceAddonProducts();
  }, 1000);

  // Try one more time to catch any late-loading elements
  setTimeout(function () {
    initializeAddonEnhancements();
    enhanceAddonProducts();
  }, 2500);

  // Handle the SPICEADDONS.Imagecheck function to prevent it from breaking our click handlers
  if (window.SPICEADDONS && typeof window.SPICEADDONS.Imagecheck === "function") {
    const originalImagecheck = window.SPICEADDONS.Imagecheck;
    window.SPICEADDONS.Imagecheck = function (img) {
      // Call the original function
      const result = originalImagecheck.call(this, img);

      // After the original function is called, re-initialize our handlers
      setTimeout(function () {
        initializeAddonEnhancements();
      }, 100);

      return result;
    };
  }
});

// Function to initialize the addon UI enhancements
function initializeAddonEnhancements() {
  // Get all addon product items
  const addonItems = document.querySelectorAll(".spice-spa-addon-product-item");

  if (!addonItems.length) return;

  // Process each addon item
  addonItems.forEach((item) => {
    // Get the checkbox within this item
    const checkbox = item.querySelector(".spice-spa-addon-checkbox-input");
    const checkboxContainer = item.querySelector(".spice-spa-addon-checkbox");

    // Hide the checkbox container visually but keep it in the DOM for functionality
    if (checkboxContainer) {
      checkboxContainer.style.position = "absolute";
      checkboxContainer.style.opacity = "0";
      checkboxContainer.style.pointerEvents = "none";
    }

    // Make the entire item clickable
    item.style.cursor = "pointer";
    item.style.position = "relative";
    item.style.transition = "all 0.2s ease";

    // Add border styling to all items
    item.style.border = "1px solid #ccc";
    item.style.borderRadius = "8px";

    // Ensure image container is clickable
    const imageContainer = item.querySelector(".spice-spa-addon-product-image");
    if (imageContainer) {
      imageContainer.style.position = "relative";
      imageContainer.style.cursor = "pointer";
      imageContainer.style.zIndex = "1";

      // Add direct click handler to image container
      if (!imageContainer.dataset.hasClickHandler) {
        imageContainer.dataset.hasClickHandler = "true";
        imageContainer.addEventListener("click", function (e) {
          // Don't let event bubble to prevent double-toggling
          e.stopPropagation();
          toggleAddonSelection(item, checkbox);
        });
      }
    }

    // If checkbox is already checked, add the selection style
    if (checkbox && checkbox.checked) {
      item.style.border = "2px solid #36B7B2";
      item.classList.add("selected-addon");
    }

    // Make product images clickable for selection
    // We need to replace the onclick attribute with our own handler
    const images = item.querySelectorAll("img");
    images.forEach((img) => {
      img.style.cursor = "pointer";

      // Only if the image doesn't already have our handler
      if (!img.dataset.hasCustomClickHandler) {
        img.dataset.hasCustomClickHandler = "true";

        // Save original onclick if it exists
        if (img.hasAttribute("onclick")) {
          img.dataset.originalOnclick = img.getAttribute("onclick");
          img.removeAttribute("onclick");
        }

        // Add our own click handler
        img.addEventListener("click", function (e) {
          e.stopPropagation(); // Prevent other handlers

          // Toggle the addon selection
          toggleAddonSelection(item, checkbox);

          // If there was an original onclick, execute it after a short delay
          // This ensures addon selection happens first
          if (img.dataset.originalOnclick) {
            setTimeout(function () {
              try {
                new Function(img.dataset.originalOnclick)();
              } catch (error) {
                console.error("Error executing original onclick:", error);
              }
            }, 10);
          }
        });
      }
    });

    // Make links in title behave like the container
    const titleLinks = item.querySelectorAll(".spice-spa-addon-product-link");
    titleLinks.forEach((link) => {
      link.style.cursor = "pointer";
      if (!link.dataset.hasClickHandler) {
        link.dataset.hasClickHandler = "true";
        link.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          toggleAddonSelection(item, checkbox);
        });
      }
    });

    // Make title container clickable
    const titleContainer = item.querySelector(".spice-spa-addon-product-title");
    if (titleContainer && !titleContainer.dataset.hasClickHandler) {
      titleContainer.dataset.hasClickHandler = "true";
      titleContainer.style.cursor = "pointer";
      titleContainer.addEventListener("click", function (e) {
        if (e.target === this) {
          e.stopPropagation();
          toggleAddonSelection(item, checkbox);
        }
      });
    }

    // Add click event to the entire product item if it doesn't have one yet
    if (!item.dataset.hasClickHandler) {
      item.dataset.hasClickHandler = "true";

      // Add click event to the entire product item
      item.addEventListener("click", function (e) {
        // Let these specific elements handle their own clicks
        if (e.target.tagName === "BUTTON" || e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA" || (e.target.tagName === "A" && !e.target.classList.contains("spice-spa-addon-product-link"))) {
          return;
        }

        // Toggle the checkbox state and update styling
        toggleAddonSelection(item, checkbox);
      });
    }

    // Add change event listener to checkbox to ensure synchronization
    if (checkbox && !checkbox.dataset.hasChangeHandler) {
      checkbox.dataset.hasChangeHandler = "true";
      checkbox.addEventListener("change", function () {
        updateAddonStyle(item, this.checked);
      });
    }
  });
}

// Helper function to toggle addon selection
function toggleAddonSelection(addonItem, checkbox) {
  if (!checkbox) return;

  // Toggle the checkbox state
  checkbox.checked = !checkbox.checked;

  // Dispatch change event to trigger any existing event listeners
  const event = new Event("change", { bubbles: true });
  checkbox.dispatchEvent(event);

  // Update visual style
  updateAddonStyle(addonItem, checkbox.checked);
}

// Helper function to update addon style based on selection state
function updateAddonStyle(addonItem, isSelected) {
  if (isSelected) {
    addonItem.style.border = "2px solid #36B7B2";
    addonItem.classList.add("selected-addon");
  } else {
    addonItem.style.border = "1px solid #ccc";
    addonItem.classList.remove("selected-addon");
  }
}

// Function to add product descriptions to addon items
function enhanceAddonProducts() {
  const addonItems = document.querySelectorAll(".spice-spa-addon-product-item");

  if (!addonItems || addonItems.length === 0) return;

  addonItems.forEach(function (item) {
    // Get product ID and title element
    const productId = item.id.replace("spice_product_main_block_", "");
    const titleElement = item.querySelector(".spice-spa-addon-product-title");

    // Skip if no product ID or title element
    if (!productId || !titleElement) return;

    // Get product handle from the input field
    const handleInput = item.querySelector('input[name="spice_productid"]');
    const productHandle = handleInput ? handleInput.getAttribute("handle") : null;

    if (!productHandle) return;

    // Check if we already processed this item
    if (!item.dataset.metafieldsProcessed) {
      // Fetch product metafields using our custom template
      fetch(`/products/${productHandle}?view=metafields-only`)
        .then((response) => response.text())
        .then((html) => {
          try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            // Get the JSON data
            const jsonScript = doc.querySelector("#product-metafields-json");
            if (!jsonScript) {
              console.error("No metafields JSON found for product:", productHandle);
              return;
            }

            const metafieldData = JSON.parse(jsonScript.textContent);

            // Get exclusion values from JSON
            const excludeFromDtc = metafieldData.custom.exclude_from_dtc === true;
            // Get customer data from JSON
            const isB2B = metafieldData.customer.is_b2b === true;
            // Hide the addon if it should be excluded
            if (excludeFromDtc && !isB2B) {
              item.style.display = "none";
              return;
            }

            // Check for direct data attributes first (most reliable)
            const metafieldContainer = doc.querySelector("div[data-metafield-custom-addon-desc], div[data-metafield-custom-addon-title]");
            let foundDesc = false;
            let foundTitle = false;

            if (metafieldContainer) {
              // Get description from data attribute
              const addonDesc = metafieldContainer.getAttribute("data-metafield-custom-addon-desc");
              if (addonDesc) {
                let descriptionElement = item.querySelector(".addon-product-description");
                if (!descriptionElement) {
                  descriptionElement = document.createElement("div");
                  descriptionElement.className = "addon-product-description";
                  descriptionElement.style.fontSize = "13px";
                  descriptionElement.style.color = "#919090";
                  descriptionElement.style.padding = "0 5px";
                  descriptionElement.style.lineHeight = "1.4";
                  descriptionElement.style.textAlign = "center";

                  // Insert after title
                  titleElement.parentNode.insertBefore(descriptionElement, titleElement.nextSibling);
                }
                descriptionElement.innerHTML = addonDesc;
                foundDesc = true;
              }

              // Get title from data attribute
              const addonTitle = metafieldContainer.getAttribute("data-metafield-custom-addon-title");
              if (addonTitle) {
                updateAddonTitle(item, addonTitle);
                foundTitle = true;
              }
            }

            // If data attributes didn't work, try checking for old-style elements
            if (!foundDesc || !foundTitle) {
              const descElement = doc.querySelector('[data-metafield="custom.addon_desc"]');
              const titleElement = doc.querySelector('[data-metafield="custom.addon_title"]');

              // Apply description if available and not already found
              if (!foundDesc && descElement && descElement.textContent.trim()) {
                let descriptionElement = item.querySelector(".addon-product-description");
                if (!descriptionElement) {
                  descriptionElement = document.createElement("div");
                  descriptionElement.className = "addon-product-description";
                  descriptionElement.style.fontSize = "13px";
                  descriptionElement.style.color = "#919090";
                  descriptionElement.style.padding = "0 5px";
                  descriptionElement.style.lineHeight = "1.4";
                  descriptionElement.style.textAlign = "center";

                  // Insert after title
                  titleElement.parentNode.insertBefore(descriptionElement, titleElement.nextSibling);
                }
                descriptionElement.innerHTML = descElement.textContent.trim();
                foundDesc = true;
              }

              // Apply title if available and not already found
              if (!foundTitle && titleElement && titleElement.textContent.trim()) {
                updateAddonTitle(item, titleElement.textContent.trim());
                foundTitle = true;
              }
            }

            // If still not found, try to parse JSON
            if (!foundDesc || !foundTitle) {
              const jsonScript = doc.querySelector("#product-metafields-json");
              if (jsonScript) {
                try {
                  const metafieldData = JSON.parse(jsonScript.textContent);

                  if (metafieldData && metafieldData.custom) {
                    // Apply description if available and not already found
                    if (!foundDesc && metafieldData.custom.addon_desc) {
                      let descriptionElement = item.querySelector(".addon-product-description");
                      if (!descriptionElement) {
                        descriptionElement = document.createElement("div");
                        descriptionElement.className = "addon-product-description";
                        descriptionElement.style.fontSize = "13px";
                        descriptionElement.style.color = "#919090";
                        descriptionElement.style.padding = "0 5px";
                        descriptionElement.style.lineHeight = "1.4";
                        descriptionElement.style.textAlign = "center";

                        // Insert after title
                        titleElement.parentNode.insertBefore(descriptionElement, titleElement.nextSibling);
                      }
                      descriptionElement.innerHTML = metafieldData.custom.addon_desc;
                      foundDesc = true;
                    }

                    // Apply custom title if available and not already found
                    if (!foundTitle && metafieldData.custom.addon_title) {
                      updateAddonTitle(item, metafieldData.custom.addon_title);
                      foundTitle = true;
                    }
                  }
                } catch (e) {
                  console.error("Error parsing JSON metafields data:", e);
                }
              }
            }

            // Remove description element if no description found
            if (!foundDesc && item.querySelector(".addon-product-description")) {
              item.querySelector(".addon-product-description").remove();
            }

            // Mark item as processed
            item.dataset.metafieldsProcessed = "true";
          } catch (e) {
            console.error("Error processing metafields response:", e);
            if (item.querySelector(".addon-product-description")) {
              item.querySelector(".addon-product-description").remove();
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching product metafields:", error);
          if (item.querySelector(".addon-product-description")) {
            item.querySelector(".addon-product-description").remove();
          }
        });
    }
  });
}

// Helper function to update addon title in all places
function updateAddonTitle(item, newTitle) {
  if (!newTitle || !item) return;

  // Skip empty or whitespace-only titles
  if (newTitle.trim() === "") return;

  const titleContainer = item.querySelector(".spice-spa-addon-product-title");
  if (!titleContainer) return;

  const titleLink = titleContainer.querySelector(".spice-spa-addon-product-link");

  // Update both the container and the link inside it
  if (titleLink) {
    titleLink.textContent = newTitle;
  } else {
    titleContainer.textContent = newTitle;
  }

  // Also update the checkbox label if it exists
  const checkboxLabel = item.querySelector(".spice-spa-addon-checkbox-label .sg_sr-only");
  if (checkboxLabel) {
    checkboxLabel.textContent = "Checkbox for " + newTitle;
  }
}

// Set up a MutationObserver to detect when new addon items are added
const addonContainer = document.getElementById("spiceaddonsappid");
if (addonContainer) {
  const observer = new MutationObserver(function (mutations) {
    let shouldUpdate = false;

    mutations.forEach(function (mutation) {
      if (mutation.type === "childList" || (mutation.type === "attributes" && mutation.target.classList.contains("spice-spa-addon-product-item"))) {
        shouldUpdate = true;
      }
    });

    if (shouldUpdate) {
      initializeAddonEnhancements();
      enhanceAddonProducts();
    }
  });

  observer.observe(addonContainer, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "style"],
  });
}
